import {createStore} from "vuex"

const store = createStore({
    state: {
        currency: null,
        userGeneralInfo: typeof (localStorage.getItem('userGeneralInfo')) != "undefined" ? localStorage.getItem('userGeneralInfo') : null,
        userEmailOrPhone: typeof (localStorage.getItem('userEmailOrPhone')) != "undefined" ? localStorage.getItem('userEmailOrPhone') : null,
        userSendMoneyHash: typeof (localStorage.getItem('userSendMoneyHash')) != "undefined" ? localStorage.getItem('userSendMoneyHash') : null,
        balanceLimitHash: typeof (localStorage.getItem('balanceLimitHash')) != "undefined" ? localStorage.getItem('balanceLimitHash') : null,
        userSendMoneyAmount: typeof (localStorage.getItem('userSendMoneyAmount')) != "undefined" ? localStorage.getItem('userSendMoneyAmount') : null,
        loggedInUser: typeof (localStorage.getItem('loggedInUser')) != "undefined" ? localStorage.getItem('loggedInUser') : null,
        accountData: typeof (localStorage.getItem('accountData')) != "undefined" ? localStorage.getItem('accountData') : null,
        userRequestSendMoneyData: typeof (localStorage.getItem('userRequestSendMoneyData')) != "undefined" ? localStorage.getItem('userRequestSendMoneyData') : null,
        userRequestSendMoneyHash: typeof (localStorage.getItem('userRequestSendMoneyHash')) != "undefined" ? localStorage.getItem('userRequestSendMoneyHash') : null,
        dashboardFeatures: typeof (localStorage.getItem('dashboardFeatures')) != "undefined" ? localStorage.getItem('dashboardFeatures') : null,
        updateStaffData: typeof (localStorage.getItem('updateStaffData')) != "undefined" ? localStorage.getItem('updateStaffData') : null,
        transactionDetail: typeof (localStorage.getItem('transactionDetail')) != "undefined" ? localStorage.getItem('transactionDetail') : null,
        paymentLinkDetail: typeof (localStorage.getItem('paymentLinkDetail')) != "undefined" ? localStorage.getItem('paymentLinkDetail') : null,
        checkPaymentData: typeof (localStorage.getItem('checkPaymentData')) != "undefined" ? localStorage.getItem('checkPaymentData') : null,
    },
    getters: {
        getCurrencyData(state) {
            return state.currency
        },
        /*checkPaymentData*/
        getCheckPaymentData(state) {
            return JSON.parse(state.checkPaymentData)
        }
        ,getLoggedInUser(state) {
            return JSON.parse(state.loggedInUser)
        },
        getAccountData(state) {
            return JSON.parse(state.accountData)
        },
        /*
        |--------------------------------------------------------------------------
        | Send Money Api Store Getter
        |--------------------------------------------------------------------------
        |
        | Register Your Send Money Getter Here
        |
        */

        // send money data getter starts
        getUserGeneralInfoData(state) {
            return JSON.parse(state.userGeneralInfo)
        },
        getUserEmailOrPhoneData(state) {
            return state.userEmailOrPhone
        },
        getUserSendMoneyHash(state) {
            return state.userSendMoneyHash
        },
        getUserSendMoneyAmount(state) {
            return state.userSendMoneyAmount
        },
        // send money data getter ends

        /*
         |--------------------------------------------------------------------------
         | Request Money Api Store Getter
         |--------------------------------------------------------------------------
         |
         | Register Your Request Money Getter Here
         |
         */

        // request money data getter starts
        getUserRequestSendMoneyData(state) {
            return JSON.parse(state.userRequestSendMoneyData)
        },
        getUserRequestSendMoneyHash(state) {
            return state.userRequestSendMoneyHash
        },
        // request money data getter ends


        /*
        |--------------------------------------------------------------------------
        | Deposit Money Api Store Getter
        |--------------------------------------------------------------------------
        |
        | Register Your Deposit Money Getter Here
        |
        */

        // deposit money data getter starts
        getBalanceLimitHash(state) {
            return state.balanceLimitHash
        },
        // deposit money data getter ends

        /*
        |--------------------------------------------------------------------------
        | Dashboard Feature Api Store Getters
        |--------------------------------------------------------------------------
        |
        | Register Your Dashboard Feature Getters Here
        |
        */

        // dashboard features data getter starts
        getDashboardFeatures(state) {
            return JSON.parse(state.dashboardFeatures)
        },
        // dashboard features data getter ends

        /*
        |--------------------------------------------------------------------------
        | Update Staff Data Api Store Getters
        |--------------------------------------------------------------------------
        |
        | Register Your Update Staff Data Getters Here
        |
        */

        // updateStaffData data getter starts
        getUpdateStaffData(state) {
            return JSON.parse(state.updateStaffData)
        },
        // updateStaffData data getter ends


        /*
        |--------------------------------------------------------------------------
        | Transaction Detail Store Getters
        |--------------------------------------------------------------------------
        |
        | Register Your Transaction Detail Getters Here
        |
        */

        // transactionDetail data getter starts
        getTransactionDetail(state) {
            return JSON.parse(state.transactionDetail)
        },
        // transactionDetail data getter ends


        /*
        |--------------------------------------------------------------------------
        | Payment LinkDetail Store Getters
        |--------------------------------------------------------------------------
        |
        | Register Your Payment LinkDetail Getters Here
        |
        */

        // paymentLinkDetail data getter starts
        getPaymentLinkDetail(state) {
            return JSON.parse(state.paymentLinkDetail)
        },
        // paymentLinkDetail data getter ends
    },

    // Mutation for when you use it as state property
    mutations: {
        setCurrencyData(state, data) {
            state.currency = data;
        },
        /*checkPaymentData*/
        setCheckPaymentData(state, data) {
            localStorage.setItem('checkPaymentData', JSON.stringify(data));
            state.checkPaymentData = localStorage.getItem('checkPaymentData');
        },
        setLoggedInUser(state, data) {
            localStorage.setItem('loggedInUser', JSON.stringify(data));
            state.loggedInUser = localStorage.getItem('loggedInUser');
        },
        setAccountData(state, data) {
            localStorage.setItem('accountData', JSON.stringify(data));
            state.accountData = localStorage.getItem('accountData');
        },
        /*
       |--------------------------------------------------------------------------
       | Send Money Api Store Mutations
       |--------------------------------------------------------------------------
       |
       | Register Your Send Money Mutations Here
       |
       */

        // send money data mutations starts
        setUserGeneralInfoData(state, data) {
            localStorage.setItem('userGeneralInfo', JSON.stringify(data));
            state.userGeneralInfo = localStorage.getItem('userGeneralInfo');
        },
        setUserEmailOrPhoneData(state, data) {
            localStorage.setItem('userEmailOrPhone', data);
            state.userEmailOrPhone = localStorage.getItem('userEmailOrPhone');
        },
        setUserSendMoneyHash(state, data) {
            localStorage.setItem('userSendMoneyHash', data);
            state.userSendMoneyHash = localStorage.getItem('userSendMoneyHash');
        },
        setUserSendMoneyAmount(state, data) {
            localStorage.setItem('userSendMoneyAmount', data);
            state.userSendMoneyAmount = localStorage.getItem('userSendMoneyAmount');
        },
        // send money data mutations ends


        /*
         |--------------------------------------------------------------------------
         | Request Money Api Store Mutations
         |--------------------------------------------------------------------------
         |
         | Register Your Request Money Mutations Here
         |
         */

        // request money data mutations starts
        setUserRequestSendMoneyData(state, data) {
            localStorage.setItem('userRequestSendMoneyData', JSON.stringify(data));
            state.userRequestSendMoneyData = localStorage.getItem('userRequestSendMoneyData');
        },
        setUserRequestSendMoneyHash(state, data) {
            localStorage.setItem('userRequestSendMoneyHash', data);
            state.userRequestSendMoneyHash = localStorage.getItem('userRequestSendMoneyHash');
        },
        // request money data mutations ends


        /*
      |--------------------------------------------------------------------------
      | Deposit Money Api Store Mutations
      |--------------------------------------------------------------------------
      |
      | Register Your Deposit Money Mutations Here
      |
      */

        // deposit money data mutations starts
        setBalanceLimitHash(state, data) {
            localStorage.setItem('balanceLimitHash', data);
            state.balanceLimitHash = localStorage.getItem('balanceLimitHash');
        },
        // deposit money data mutations ends

        /*
      |--------------------------------------------------------------------------
      | Dashboard Feature Api Store Mutations
      |--------------------------------------------------------------------------
      |
      | Register Your Dashboard Feature Mutations Here
      |
      */
        // dashboard features data mutations starts
        setDashboardFeatures(state, data) {
            localStorage.setItem('dashboardFeatures', JSON.stringify(data));
            state.dashboardFeatures = localStorage.getItem('dashboardFeatures');
        },
        // dashboard features data mutations ends

        /*
       |--------------------------------------------------------------------------
       | Update Staff Data Store Mutations
       |--------------------------------------------------------------------------
       |
       | Register Your Update Staff Data Mutations Here
       |
       */
        // update Staff data mutations starts
        setUpdateStaffData(state, data) {
            localStorage.setItem('updateStaffData', JSON.stringify(data));
            state.updateStaffData = localStorage.getItem('updateStaffData');
        },
        // update Staff data mutations ends


        /*
       |--------------------------------------------------------------------------
       | Transaction Detail Store Mutations
       |--------------------------------------------------------------------------
       |
       | Register Your Transaction Detail Mutations Here
       |
       */
        // transactionDetail mutations starts
        setTransactionDetail(state, data) {
            localStorage.setItem('transactionDetail', JSON.stringify(data));
            state.transactionDetail = localStorage.getItem('transactionDetail');
        },
        // transactionDetail mutations ends



        /*
       |--------------------------------------------------------------------------
       | Payment LinkDetail Store Mutations
       |--------------------------------------------------------------------------
       |
       | Register Your Payment LinkDetail Mutations Here
       |
       */
        // paymentLinkDetail mutations starts
        setPaymentLinkDetail(state, data) {
            localStorage.setItem('paymentLinkDetail', JSON.stringify(data));
            state.paymentLinkDetail = localStorage.getItem('paymentLinkDetail');
        },
        // paymentLinkDetail mutations ends
    },
})

export default store
